import React from "react";

function NHSNoText(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={61} height={24} viewBox="0 0 61 24" fill="none" {...props}>
      <path
        d="M60.278 24V0H.722v24h59.556zM24.704 2.32l-4.148 19.316h-6.448l-4.06-13.334h-.053L7.331 21.636H2.4L6.549 2.32h6.466l3.98 13.396h.053L19.775 2.32h4.93zm18.449 0l-4.06 19.316h-5.196l1.724-8.303h-6.147l-1.723 8.276h-5.196l4.032-19.316h5.223L30.282 9.68h6.138l1.528-7.387 5.205.027zm14.93.524l-1.252 3.85a9.764 9.764 0 00-4.28-.89c-2.053 0-3.722.303-3.722 1.858 0 2.738 7.532 1.716 7.532 7.582 0 5.334-4.974 6.72-9.478 6.72a21.814 21.814 0 01-6.004-.995l1.226-3.929a10.093 10.093 0 004.778 1.111c1.608 0 4.14-.311 4.14-2.302 0-3.102-7.533-1.938-7.533-7.387 0-4.986 4.388-6.48 8.643-6.48a15.898 15.898 0 015.95.89v-.028z"
        fill="#fff"
      />
    </svg>
  );
}

export default NHSNoText;
